<template>
  <div class="echarts" ref="container"></div>
</template>

<script>
import {
  inject, onMounted, ref, watch,
} from 'vue';

const color = [
  '#2284FE',
  '#5AD8A6',
  '#5D7092',
  '#F6BD16',
  '#E8684A',
  '#6DC8EC',
  '#9270CA',
  '#FF9D4D',
  '#269A99',
  '#FF99C3',
];

// function getEcharts() {
//   if (window.echarts) {
//     return Promise.resolve(window.echarts);
//   }
//   return new Promise((resolve) => {
//     const script = document.createElement('script');
//     script.setAttribute(
//       'src',
//       'https://cdn01.xiaogj.com/uploads/x3/assets/pc/lib/echarts/5.1.2/echarts.min.js',
//     );
//     document.body.appendChild(script);
//     script.onload = () => {
//       script.remove();
//       resolve(window.echarts);
//     };
//   });
// }
export default {
  name: 'Echarts',
  props: {
    setOption: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
  },
  setup(props) {
    const container = ref(null);
    const E = window.echarts;
    let chart = null;
    onMounted(() => {
      chart = E.init(container.value);
      watch(
        () => props.setOption,
        (option) => {
          chart.setOption({ color, ...option });
        },
        {
          immediate: true,
        },
      );
      const useResized = inject('useResized');
      useResized(() => {
        chart.resize({
          animation: {
            duration: 200,
          },
        });
      });
    });
    return {
      container,
    };
  },
};
</script>

<style scoped lang="scss">
.echarts {
  width: 100%;
  height: 100%;
  overflow: hidden;
  min-height: 100px;
}
</style>
